export const BoardsArray = [];

export class Board {
  constructor(name) {
    this.name = name;
    this.columns = [];
  }
}
